var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-12 pt-12",attrs:{"justify":"center"}},[_c('v-card',{attrs:{"width":"400"}},[_c('Authenticator',{on:{"close-window":function($event){return _vm.$router.push('/')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }